import React from "react";

import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { SupplementDosage } from "@henophess/types";

import { SupplementRecommendationsList } from "./SupplementRecommendationsList";

interface PhRecommendationsDisplayProps {
  supplementRecommendations: SupplementDosage[];
  textRecommendations: string[];
}

export const PhRecommendationsDisplay: React.FC<PhRecommendationsDisplayProps> = ({
  supplementRecommendations,
  textRecommendations
}) => {
  const bgColor = useColorModeValue("white", "gray.800");

  return (
    <Box borderWidth="1px" borderColor="brand.dark_green" borderRadius="lg" p={4} bg={bgColor}>
      {supplementRecommendations.length > 0 && (
        <Box>
          <Text textStyle="sectionTitle" mb={3}>
            Supplement Recommendations
          </Text>
          <SupplementRecommendationsList recommendations={supplementRecommendations} />
        </Box>
      )}
    </Box>
  );
};
